<template>
  <div id="selclub">
    <div
      class="header"
      :style="{
        'background-color': event.color,
        backgroundImage: 'url(' + event.logo + ')'
      }"
    >
      <div class="right">
        <Language :dark_mode="true"></Language>
        <div class="user">{{ user.user.username }}</div>
        <div @click="logout()" id="logout" class="name">{{ $t("logout") }}</div>
      </div>
    </div>
    <v-container grid-list-md text-xs-center class="selector">
      <v-layout row wrap :align-center="true" :justify-center="true">
        <v-flex xs12 class="title">
          {{ $t("home.welcome") }}
        </v-flex>
        <v-flex xs12 class="subtitle">
          {{
            !event.is_campus
              ? $t("home.club_selector_subtitle")
              : $t("home.participant_selector_subtitle")
          }}
        </v-flex>
        <v-flex xs12 sm6 md2 v-for="(club, index) in clubs" :key="index">
          <v-card-text @click="loginClub(club)" class="club">
            <img :src="shield(club.shield)" class="shield" />
            <span class="name">{{ club.name }}</span>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Language from "@/components/ui/Language.vue";
import { Api } from "@/core/api.js";
const api = new Api();

export default {
  name: "SelClub",

  components: {
    i18n,
    Language
  },

  data() {
    return {};
  },

  computed: {
    event() {
      return this.$store.getters.getCurrentEvent();
    },

    user() {
      return this.$store.getters["user/getSession"];
    },

    clubs() {
      return this.$store.getters["user/getSession"].user.clubs;
    }
  },

  created() {
    this.load();
  },

  methods: {
    load() {
      var oUser = this.$store.getters["user/getSession"];
      var clubs = this.$store.getters["user/getSession"].user.clubs;
      console.log("LOAD SEL_CLUBS: ", clubs);
      if (typeof clubs === "undefined" || clubs.length == 0) {
        this.$router.push({ name: "home" });
        this.$destroy();
      }
    },

    loginClub(club) {
      var self = this;
      this.$store
        .dispatch("user/loginClub", { club: club.id, event: this.event.id })
        .then(function(response) {
          if (response.status) {
            self.error_message = false;
            var event = self.$store.getters.getCurrentEvent();

            self.$store.commit("user/setAuthenticate", response.data);
            localStorage.setItem("token", response.data.token);

            self.$store.dispatch("loadTablesRelationship").then(function() {
              if (self.campus) {
                self.$store.commit("setCampus", true);
              }
              self.$router.push({
                name: "home",
                params: {
                  event: self.$root.formatEventUrl(event.name, event.edition)
                }
              });
            });
          } else {
            self.error_message = true;
          }
        });
    },

    logout() {
      var self = this;
      api.get("logout").then(function(data) {
        var event = self.$store.getters.getCurrentEvent();
        self.$store.commit("user/setAuthenticate", false);
        self.$store.commit("setOverlayVisible", false);
        self.$store.commit("setUserMenuVisible", false);
        var campus = self.$store.getters["getCampus"];
        // campus ? self.$router.replace( { name: 'campus_login' } ) : self.$router.replace( { name: 'login' } );
        self.$router.replace({
          name: "event_login",
          params: {
            event: self.$root.formatEventUrl(event.name, event.edition)
          }
        });
      });
    },

    shield(v) {
      if (v == null || v.trim() == "") {
        if (this.event.is_campus) {
          return "/img/avatar.svg";
        } else {
          return "/img/club_light.svg";
        }
      }
      return v;
    }
  },

  filters: {}
};
</script>

<style lang="scss">
#selclub {
  width: 100%;
  height: 100vh;
  margin: 0;
  background: linear-gradient(0deg, #ddd, #fff);
  color: $secondary-color;
  overflow: auto;

  .header {
    height: 140px;
    text-align: center;
    transition-duration: 0.2s;
    background-color: #111;
    background: linear-gradient(0deg, #ddd, #fff);
    @include background($position: center, $size: 140px);
  }

  .right {
    @include display-flex();
    @include align-items();
    padding: 0 12px;
    @include justify-content(flex-end);
    height: 100%;
    position: relative;
    float: right;
    width: 50%;
    color: #fff;

    #logout {
      @include background(
        $image: img("logout_w.svg"),
        $size: 20px,
        $position: left 6px center
      );
      padding-left: 33px;
      float: right;
      font-size: 16px;
      cursor: pointer;
      margin-left: 15px;
      color: #fff;
    }
    .user {
      margin-left: 15px;
      color: #fff;
    }
  }

  .selector {
    width: 90%;

    .title {
      font-size: 36px !important;
      line-height: 36px;
      text-align: center;
      color: $main-color;
      padding: 18px 0 0px 0;

      &:after {
        content: "";
        display: block;
        height: 2px;
        width: 40px;
        background-color: $secondary-color;
        margin: 24px auto 6px auto;
      }

      .name {
        text-transform: capitalize;
        font-size: inherit;
        color: inherit;
      }
    }

    .subtitle {
      width: 100%;
      margin: 0 auto 42px auto;
      text-align: center;
      font-size: 22px;
      line-height: 22px;
      color: #777;
    }

    .club {
      border: 2px solid $secondary-color;
      max-width: 100%;
      width: 350px;
      text-align: center;
      display: block;
      cursor: pointer;

      .shield {
        min-width: 60px;
        max-width: 50%;
        height: auto;
      }

      .name {
        width: 100%;
        font-size: 24px;
        display: block;
        text-align: center;
        font-weight: bold;
        margin-top: 15px;
        font-family: AvantGarde-Bold;
      }
    }
  }
}

@include media(">phone", "<tablet") {
  #selclub {
    .right {
      height: auto !important;
      width: 100%;
    }
  }
}

@include media(">phone", "<tablet") {
  .v-dialog.v-dialog--active {
    overflow: auto;
  }
}
</style>
